import { render, staticRenderFns } from "./AccountStudent.vue?vue&type=template&id=7f55353a&"
import script from "./AccountStudent.vue?vue&type=script&lang=js&"
export * from "./AccountStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports